import { render, staticRenderFns } from "./Combat.vue?vue&type=template&id=c79a91f8&scoped=true&"
import script from "./Combat.vue?vue&type=script&lang=js&"
export * from "./Combat.vue?vue&type=script&lang=js&"
import style0 from "./Combat.vue?vue&type=style&index=0&id=c79a91f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c79a91f8",
  null
  
)

export default component.exports